<li
  class="px-4 flex items-center cursor-pointer focus:outline-none
{{ isSelected ? 'font-bold text-white bg-blue' : 'hover:text-white hover:bg-blue text-navy' }}
 {{ classNames }} {{ classNameForVariant }}"
  (click)="handleSelect()"
>
  <ng-content></ng-content>
</li>
